<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='系统参数设置' label2="新增参数信息" url="/system/dict/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">数据类型：</label>
            <div class="col-lg-3">
              <el-form-item prop="dictid" :rules="{required: true, message: '数据类型不能为空', trigger: 'blur'}">
                <el-select v-model="form.dictid" style="width: 100%;">
                  <el-option v-for="item in Dict" :key="item.DictID" :label="item.DictName" :value="item.DictID"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">参数名称：</label>
            <div class="col-lg-3">
              <el-form-item prop="dictitemname" :rules="{required: true, message: '参数名称不能为空', trigger: 'blur'}">
                <el-input v-model="form.dictitemname" ref="inputStyle"></el-input>
              </el-form-item>
            </div>
            <label class="col-lg-2 col-form-label">参数值：</label>
            <div class="col-lg-3">
              <el-form-item prop="dictitemvalue" :rules="{required: true, message: '参数值不能为空', trigger: 'blur'}">
                <el-input v-model="form.dictitemvalue"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">参数类型：</label>
            <div class="col-lg-3">
              <el-form-item prop="dictitemtype" :rules="{required: true, message: '参数类型不能为空', trigger: 'blur'}">
                <el-input v-model="form.dictitemtype"></el-input>
              </el-form-item>
            </div>
            <label class="col-lg-2 col-form-label">显示顺序：</label>
            <div class="col-lg-3">
              <el-form-item prop="orderindex" :rules="{required: true, message: '显示顺序不能为空', trigger: 'blur'}">
                <el-input v-model="form.orderindex"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12" style="text-align: center;">
                  <SaveButton :url="saveUrl" back="/system/dict/list"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default{
  name: 'DictAdd',
  data () {
    return {
      form: {
        dictname: '',
        dictitemname: '',
        dictitemvalue: '0',
        dictitemtype: '0',
        orderindex: '1',
        dictid: '',
        token: ''
      },
      Dict: [{}],
      saveUrl: this.$utils.Url.system + '/systemapi/dictitem/add'
    }
  },
  mounted: function () {
    this.form.token = sessionStorage.getItem('token')
    var that = this
    var args = {
      token: this.form.token
    }
    this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/dictitem/dictlist', args, function (d) {
      that.Dict = d.Data
    }, null, null)
  }
}
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }
</style>
